import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "hero is-primary" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hero-body" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-3" }, "Splitta era utgifter"),
    /*#__PURE__*/_createElementVNode("h2", { class: "subtitle" }, "Like a BOSS")
  ])
], -1)
const _hoisted_2 = { class: "container is-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserList = _resolveComponent("UserList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_UserList)
    ])
  ], 64))
}